module.exports = __webpack_public_path__ + "static/img/banner09.44c41274.png";